<gh-sub-nav-options class="ml-11px mt-10px mb-10px d-block" [options]="customReportOptions"></gh-sub-nav-options>
<div class="borderline"></div>
<gh-generic-sub-navigation [options]="options" [itemsType]="'lists'" [favorites]="getFavorites()" [recent]="getRecent()" *ngIf="!hideListsFeatureFlag"></gh-generic-sub-navigation>
